"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IOptions_1 = require("./WrappedProperty/IOptions");
var WrappedProperty_1 = require("./WrappedProperty");
var fixAndMergeSchema_1 = require("./JSchema/fixAndMergeSchema");
var defaultValue_1 = require("./JSchema/defaultValue");
var fixData_1 = require("./JSchema/fixData");
var validationMessages_1 = require("./validationMessages");
var schemaMixin = {
    beforeCreate: function () {
        var vm = this;
        // constructor
        var Vue = vm.constructor;
        while (Vue.super) {
            Vue = Vue.super;
        }
        if (Vue.Renderless) {
            Vue = Vue.Renderless;
        }
        vm.$VueConstructor = Vue;
        vm.$methods = Vue.prototype.$methods = IOptions_1.defaultOptions.schemaMethods;
    },
    created: function () {
        var vm = this;
        var schema = vm.$options.schema;
        if (schema && vm.$setSchema) {
            vm.$setSchema(schema, false);
        }
    },
    beforeDestroy: function () {
        this.$setSchema();
    },
    methods: {
        $setSchema: function (schema, forceUpdate) {
            var vm = this;
            if (vm.$schema) {
                vm.$schema.$destroy();
            }
            vm.$schema = undefined;
            if (!schema) {
                return undefined;
            }
            if (vm.model === undefined) {
                throw new Error('no `model` property in data');
                return undefined;
            }
            var sopts = vm.schemaOptions || vm.$options.schemaOptions;
            var soptions = IOptions_1.fixSchemaOptions(sopts);
            if (sopts && sopts.validationMessages) {
                soptions.validationMessages = Object.assign({}, validationMessages_1.default, sopts.validationMessages);
            }
            // constructor
            soptions.Vue = vm.$VueConstructor;
            // externalv
            if (vm.$options.external) {
                soptions.external = vm.$external = vm.$options.external;
            }
            // form
            vm.$form = soptions.form = vm.form || {};
            // methods
            // vm.$methods = soptions.schemaMethods;
            // merge schema
            var schema2 = null;
            // let fixtime = new Date().getTime();
            if (process.env.NODE_ENV === 'development') {
                console.time('schema fixing time');
            }
            var fixOptions = Object.assign({}, fixAndMergeSchema_1.fixSchemaDefaultOptions);
            if (vm.$options.schemaOptions && vm.$options.schemaOptions.arrayItemGuidField !== undefined) {
                fixOptions.arrayItemGuidField = vm.$options.schemaOptions.arrayItemGuidField;
            }
            fixOptions.model = vm.model;
            if (!Array.isArray(schema)) {
                schema = [schema];
            }
            else {
                schema = schema.slice(0);
            }
            if (vm.$options.beforeFixSchema) {
                vm.$options.beforeFixSchema.call(vm, schema, fixOptions);
            }
            schema2 = fixAndMergeSchema_1.default(schema, fixOptions);
            // let ooo = JSON.stringify(schema2);
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('schema fixing time');
            }
            // console.log('schema fixing time', new Date().getTime() - fixtime);
            // const stime = new Date().getTime();
            // for (let i = 0; i < 100; i++) {
            // Object.defineProperty(this,"$schema",{
            //    enumerable: true,
            //    get: wrapobj.wrap(this, "model", schema)
            // })
            var nfix = vm.$options.schemaOptions === undefined || vm.$options.schemaOptions.fixData === undefined || vm.$options.schemaOptions.fixData === true;
            if (vm.model === null) {
                // tworzenie domyslnego
                if (nfix) {
                    vm.model = defaultValue_1.default(schema2, true);
                }
                else {
                    vm.model = {};
                }
            }
            else {
                if (nfix) {
                    if (process.env.NODE_ENV === 'development') {
                        console.time('fixData');
                    }
                    var fixed = fixData_1.default(schema2, vm.model, soptions.Vue);
                    if (process.env.NODE_ENV === 'development') {
                        console.timeEnd('fixData');
                        if (fixed) {
                            console.log('fixed fields: ' + fixed);
                        }
                    }
                }
            }
            if (vm.$options.beforeSchema) {
                vm.$options.beforeSchema.call(vm, vm.model, schema2, soptions);
            }
            // if (process.env.NODE_ENV === 'development') {
            //    console.log('$schema.options', soptions);
            // }
            // console.log('wrapping model', vm.model);
            // vm.$schema = wrapobj.wrap(vm, schema2, 'model');
            // vm.$schema = new WrappedPropertyObject(null, vm, 'model', schema2, soptions);
            if (process.env.NODE_ENV === 'development') {
                console.time('wrapping schema');
            }
            vm.$schema = new WrappedProperty_1.default[schema2.type](null, vm, 'model', schema2, soptions);
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('wrapping schema');
            }
            if (vm.$options.afterSchema) {
                vm.$options.afterSchema.call(vm, vm.$schema);
            }
            // console.log('wrapping schema', vm.$schema);
            // }
            // tslint:disable-next-line: no-console
            // console.log('wraptime', new Date().getTime() - stime, vm.$schema);
            if (forceUpdate && vm.$forceUpdate) {
                vm.$forceUpdate();
            }
            return vm.$schema;
        }
    }
    /*
      destroyed() {
          const vm: any = this as any;
      },
      */
    /*
        directives: {
            schema: {
                bind: (el: any, binding: any, vnode: any) => {
                    if (vnode && vnode.componentInstance && vnode.componentInstance.setModel) {
                        vnode.componentInstance.setModel(binding.value, binding.modifiers);
  
                    }
                },
            },
        },
        */
};
exports.default = schemaMixin;
//# sourceMappingURL=schemaMixin.js.map